import { render, staticRenderFns } from "./no-win-dialog.vue?vue&type=template&id=52732e36&scoped=true&lang=pug&"
import script from "./no-win-dialog.vue?vue&type=script&lang=js&"
export * from "./no-win-dialog.vue?vue&type=script&lang=js&"
import style0 from "./no-win-dialog.vue?vue&type=style&index=0&id=52732e36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52732e36",
  null
  
)

export default component.exports